import { Image } from '@chakra-ui/react'

import MangbangLogoPng from '@images/mangabang_logo.png'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'

export const BrandLogo = (props) => {
  return <Image alt="マンガBANGブックス" src={buildAssetUrlString(MangbangLogoPng)} {...props} />
}
